module.exports = __webpack_public_path__ + "static/site-vitrine-e87a809643c9c3ccf12747550378a19b.jpg";